<template>
  <div>
    <iframe
      name="freem"
      id="dash"
      src="https://stats.uptimerobot.com/460P5cA2M"
      frameborder="0"
      style="width: 100%; overflow: hidden; height: 1000px;"
      onload="resizeIframe(this);"
      scrolling="no"
    ></iframe>
  </div>
</template>
<script>
export default {
  name: 'ServerStatus',
};
</script>
